import { __spreadArray, __read } from 'tslib';

/**
 * Returns a string for Voiceover
 * Currently it supports 3 cases
 * 1. Single date - "your current month is May 2023"
 * 2. Two consecutive months - "your current months are May 2023 and June 2023"
 * 3. For multiple months - "your current months are between May 2023 and October 2023"
 *
 * @param {string} month
 * @param {string} year
 * @param {string} numMonthsToDisplay
 * @param {ILocalization} l10n - Localization Object
 * @return {string}
 */
var getAriaLiveLabel = function (month, year, numMonthsToDisplay, l10n) {
  var startMonth = new Date(year, month, 1, 12);
  var monthArray = [startMonth.toLocaleString('default', {
    month: 'long'
  }), year];
  if (numMonthsToDisplay === 1) {
    return l10n.formatText('calendar.ariaLabelSingleMonthChange', monthArray);
  }
  var endMonth = new Date(year, month + numMonthsToDisplay - 1, 1, 12);
  monthArray = __spreadArray(__spreadArray([], __read(monthArray), false), [endMonth.toLocaleString('default', {
    month: 'long'
  }), endMonth.toLocaleString('default', {
    year: 'numeric'
  })], false);
  if (numMonthsToDisplay === 2) {
    return l10n.formatText('calendar.ariaLabelMonthChange', monthArray) || '';
  }
  return l10n.formatText('calendar.ariaLabelMultiMonthChange', monthArray) || '';
};
export { getAriaLiveLabel as default };